import CONSTANT from '@/constant'
import Router from '@/router'
import store from '../store'
import {
  Message
} from 'element-ui'
export default (result) => {
  // 是否有返回值，并且检查状态码是否是成功
  const {
    status
  } = result
  const {
    data,
    code
  } = result.data

  // CONSTANT.AJAX_SUCCESS 以常量形式存储
  if (result && (code === CONSTANT.RES_CODE) && status === CONSTANT.AJAX_SUCCESS) {
    localStorage.removeItem('code')
    if (result.data.msg) {
      Message({
        message: result.data.msg,
        type: 'success'
      })
    }
    // return data || result.data || result
    return data
  } else if (code === CONSTANT.NO_TOKEN || code === CONSTANT.INVALID_TOKEN) {
    localStorage.setItem('code', code)
    localStorage.removeItem('user')
    store.dispatch('logout', code)
    if (code === CONSTANT.NO_TOKEN && localStorage.getItem('accessToken')) {
      Message({
        message: '登录超时，请重新登录！',
        type: 'error',
        duration: 5000
      })
    }
    Router.push({
      path: '/login'
    })
  } else if (code === CONSTANT.NO_PERMISSION) {
    localStorage.setItem('code', code)
    localStorage.removeItem('user')
    store.dispatch('logout', code)
    if (result.data.msg !== undefined) {
      Message({
        message: result.data.msg,
        type: 'error'
      })
    }
    Router.push({
      path: '/login'
    })
  } else {
    localStorage.removeItem('code')
    if (result.data.msg !== undefined) {
      Message({
        message: result.data.msg,
        type: 'error'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/errorData.js